import {FC, PropsWithChildren} from 'react';
import {colorCellStyles as STYLES} from './StatusColorCell.styles';
import {Box} from '@mui/material';

export const StatusColorCell: FC<PropsWithChildren> = ({children}) => {
  return <Box sx={STYLES.cell}>{children}</Box>;
};
